import { useContext, useEffect, useState } from "react";
import CartClass from "../classes/CartClass";
import { ADDR_TYPE_CHOICES, BASKET_TYPE_CHOICES, CATEGORY_CHOICES } from "../components/Enumerators";
import CartItem from "./cart/CartItem";
import RequestClass from "../classes/RequestClass";
import { IOrder } from "../interfaces/IOrder";
import { CartContext } from "../context/CartContext";
import { ContactForm } from "../components/forms/ContactForm";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IUrlProductList } from "../interfaces/IUrl";
import ProdBreadCrumb from "./products/ProdBreadCrumb";
import { ICartProduct } from "../interfaces/ICartProduct";
import { isMobile } from "react-device-detect";
import PageTitle from "../components/layout/PageTitle";
import BodyContainer from "../components/layout/BodyContainer";
import { NoOrphans } from "../components/elements/NoOrphans";
import { UserContext } from "../context/UserContext";

const Inquiry = () => {
    const basketType = BASKET_TYPE_CHOICES.BASKET_INQUIRY;
    const { setInquiryCnt } = useContext(UserContext);
    // const [isLoaded, setIsLoaded] = useState(false);
    const [notification, setNotification] = useState<JSX.Element | String>();
    const urlParams = useParams<IUrlProductList>();
    const [basketId] = useState(
        urlParams.basketId
            ? () => {
                  CartClass.set_basketId(BASKET_TYPE_CHOICES.BASKET_INQUIRY, urlParams.basketId);
                  return urlParams.basketId;
              }
            : CartClass.get_basketId(basketType)
    );

    const [isSent, setIsSent] = useState(false);
    const navigate = useNavigate();

    // wszystkie dane związane z zapytaniem ofertowym
    const [order, setOrder] = useState<IOrder>({
        products: [] as ICartProduct[],
        addrContact: {
            addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_CONTACT_BY_USER,
            aName: "",
        },
    });

    // const [addrContact, setAddrContact] = useState<IAddr|undefined>(order?.addrContact)

    /* -----
     *  wysłanie zapytania o koszyk -> przy zmianie basketId
     * ----- */
    //console.log(isLoaded)
    useEffect(() => {
        function succ_callback(result: any) {
            if (result !== null) {
                if (order !== undefined) {
                    if (setOrder) {
                        setOrder({ ...order, products: result.products });
                    }
                }
            }
            // try {
            //     setInquiryCnt(result.products.length);
            //   } catch (e) {console.log(e)}
            // setIsLoaded(true);
        }

        function err_callback(result: any) {
            setNotification(RequestClass.errorAlert(result));
        }
        // log(urlParams.basketId);
        // wysłanie zapytanie do serwera
        CartClass.get(
            BASKET_TYPE_CHOICES.BASKET_INQUIRY,
            // urlParams.basketId
            //     ? BASKET_TYPE_CHOICES.BASKET_OFFER
            //     : BASKET_TYPE_CHOICES.BASKET_INQUIRY,
            succ_callback,
            err_callback
            // urlParams.basketId
        );
    }, [basketId]);

    function isProduct() {
        if (order.products !== undefined) if (order.products?.length > 0) return true;
        return false;
    }

    useEffect(() => {
        if (isSent === true) {
            /* formularz został poprawnie wysłany */
            setInquiryCnt(0);
            //CartClass.set_basketId(BASKET_TYPE_CHOICES.BASKET_INQUIRY, "")
            navigate("/zapytanie/sukces");
        }
    }, [isSent]);

    return (
        <>
            {notification}

            <PageTitle>
                <ProdBreadCrumb
                    categoryId={urlParams.categoryId ? urlParams.categoryId : CATEGORY_CHOICES.CATEGORY_CLOSE}
                    level3Title="Zapytanie ofertowe"
                />
                <div>
                    Chętnie zorganizujemy dla Ciebie szkolenie. <br />
                    Napisz do nas.
                </div>
            </PageTitle>

            <BodyContainer noPadding={false}>
                <div className="columns my-4 ">
                    {isProduct() && (
                        <div className="column ">
                            <h2 className="is-size-5 is-size-6-mobile">Jestem zainteresowany następującymi szkoleniami:</h2>

                            <div id="cart" className="block">
                                <CartContext.Provider
                                    value={{
                                        basketId,
                                        order,
                                        setOrder,
                                        setNotification,
                                    }}
                                >
                                    {order?.products?.map((cartProduct) => (
                                        <CartItem key={cartProduct.product?.productId} cartProduct={cartProduct} />
                                    ))}
                                </CartContext.Provider>
                            </div>
                            <div className="mt-5 mb-5 has-text-left">
                                <Link
                                    to={urlParams.categoryId !== undefined ? "/list/" + urlParams.categoryId : "/"}
                                    className="mr-2 button is-primary is-outlined"
                                >
                                    {isMobile ? <>chcę dodać kolejne szkolenie</> : <>chcę dodać kolejne szkolenie z oferty sklepu</>}
                                </Link>

                                <NoOrphans className="mt-5 is-size-6 is-size-7-mobile">
                                    Jeżeli nie znalazłeś w ofercie szkolenia, które Cię interesuje, napisz do nas. Z przyjemnością zoorganizujemy
                                    szkolenie według Twoich indywidualnych potrzeb.
                                </NoOrphans>
                            </div>
                        </div>
                    )}
                    <div className="column box">
                        <ContactForm
                            order={order}
                            title=" "
                            setIsSent={setIsSent}
                            infoLabel="dodatkowe informacje (liczba uczestników, proponowane terminy)"
                        />
                    </div>
                </div>
            </BodyContainer>
        </>
    );
};
export default Inquiry;
